import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return {
    root: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    icon: {
      borderRadius: '50%',
      width: '16px',
      height: '16px',
      backgroundColor: 'transparent',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: theme.colorTokens.outlineVariant,
    },
    checkedIcon: {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.main,
      '&:after': {
        content: '""',
        display: 'block',
        width: '10px',
        height: '10px',
        margin: '3px',
        borderRadius: '50%',
        backgroundColor: theme.colors.common11,
      },
    },
  };
};
